module.exports = __webpack_public_path__ + "img/top-banner-bg.bf51885f.png";